// import moment from "moment";
import * as R from "ramda";

import { createSelector } from "reselect";
import { getters } from "Portal/NewPortal/PortalHome/model";
// import { getters as SearchBarGetters } from "ui-kit/SearchBar";
// import { TASKS_ORDER, CART_REQUESTS_ID } from "Portal/PortalHome/constants";
// import { TASKS_ORDER } from "Portal/PortalHome/constants";
import { ACTION_TYPES } from "ui-kit/Table/constants";

// import { ROW_ACTIONS_ITEMS, FILTER } from "Portal/PortalHome/constants";
import { ROW_ACTIONS_ITEMS } from "Portal/PortalHome/constants";
// import { getDate7DaysAgo } from "Portal/NewPortal/PortalHome/utils";
import { SECTIONS_MENU } from "Portal/NewPortal/PortalHome/constants";
import { SECTIONS_IDS } from "../constants";
import { eventDetails as getEventDetails } from "redux/modules/portal/selectors";

export const getRowActions = R.always([
  {
    id: ROW_ACTIONS_ITEMS.OPEN_SUBMISSION_MODAL,
    type: ACTION_TYPES.ITEM,
    name: "Open Submission Modal",
    leftIcon: "open_in_new"
  },
  {
    id: ROW_ACTIONS_ITEMS.EDIT_ROW,
    type: ACTION_TYPES.ITEM,
    name: "Edit",
    leftIcon: "edit"
  },
  {
    id: ROW_ACTIONS_ITEMS.DELETE_ROW,
    type: ACTION_TYPES.ITEM,
    name: "Delete",
    leftIcon: "delete"
  }
]);

export const getMySessionsTitle = createSelector(
  getEventDetails,
  eventDetails => {
    // handle: SABCS custom header
    return eventDetails.org_id === "be6268dd-ac99-4d19-94a4-af1ca2acd763"
      ? "My Abstracts"
      : "My Sessions";
  }
);

export const getPortalMeta = createSelector(getters.portalMeta, meta => meta);

export const getFiles = createSelector(getters.files, files => files);
export const getHasFiles = createSelector(
  getters.files,
  files => files.length > 0
);
export const getHasSessions = createSelector(
  getters.sessions,
  sessions => sessions.length > 0
);
export const getHasApplications = createSelector(
  getters.applications,
  applications => applications.length > 0
);

export const getLengthFiles = createSelector(getFiles, R.length);

export const getSessions = createSelector(
  getters.sessions,
  sessions => sessions
);

export const getWikiPages = createSelector(getters.pages, pages => pages);
export const getHasResources = createSelector(
  getters.pages,
  pages => pages.length > 0
);

export const getApplications = createSelector(
  getters.applications,
  applications => applications
);

export const getPages = createSelector(getters.pages, pages => pages);

export const getAlerts = createSelector(getters.alerts, alerts => alerts);

export const getLinks = createSelector(getters.gleanin_links, links => links);

export const getSectionIconById = id => {
  const item = R.find(R.propEq("id", id), SECTIONS_MENU);
  return R.prop("icon", item);
};

export const getSelectedCategory = createSelector(
  (_, props) => props.routes,
  routes => {
    if (R.any(R.propEq("name", "PortalSessions"))(routes)) {
      return SECTIONS_IDS.SESSIONS;
    } else if (R.any(R.propEq("name", "PortalResources"))(routes)) {
      return SECTIONS_IDS.RESOURCES;
    } else if (R.any(R.propEq("name", "PortalResourcesResource"))(routes)) {
      return SECTIONS_IDS.RESOURCES;
    } else if (R.any(R.propEq("name", "PortalCalendar"))(routes)) {
      return SECTIONS_IDS.CALENDAR;
    } else if (R.any(R.propEq("name", "PortalFiles"))(routes)) {
      return SECTIONS_IDS.FILES;
    } else if (R.any(R.propEq("name", "PortalHistory"))(routes)) {
      return SECTIONS_IDS.HISTORY;
    } else if (R.any(R.propEq("name", "PortalMessages"))(routes)) {
      return SECTIONS_IDS.MESSAGES;
    } else if (R.any(R.propEq("name", "PortalTasks"))(routes)) {
      return SECTIONS_IDS.TASKS;
    } else if (R.any(R.propEq("name", "PortalProfile"))(routes)) {
      return SECTIONS_IDS.PROFILE;
    }
    return SECTIONS_IDS.HOME;
  }
);

export const getPageTitle = createSelector(
  getSelectedCategory,
  getEventDetails,
  (selectedCategory, eventDetails) => {
    const page = R.propOr("Home", selectedCategory, {
      [SECTIONS_IDS.HOME]: "Home",
      [SECTIONS_IDS.SESSIONS]: "Sessions",
      [SECTIONS_IDS.PROFILE]: "Profile",
      [SECTIONS_IDS.HISTORY]: "History",
      [SECTIONS_IDS.TASKS]: "Tasks",
      [SECTIONS_IDS.FILES]: "Files",
      [SECTIONS_IDS.RESOURCES]: "Resources",
      [SECTIONS_IDS.CALENDAR]: "Calendar",
      [SECTIONS_IDS.MESSAGES]: "Messages"
    });

    return `${eventDetails.name} - Portal - ${page}`;
  }
);

export const getIsManageSessionsEnabled = createSelector(
  getters.enableManageSessions,
  enableManageSessions => {
    return enableManageSessions;
  }
);

export const getIsViewSessionFormEnabled = createSelector(
  getters.enableViewSessionSubmissionForm,
  R.identity
);

export const getIsManageProfileEnabled = createSelector(
  getters.enableManageProfile,
  enableManageProfile => {
    return enableManageProfile;
  }
);

export const getShouldShowSessions = createSelector(
  getters.show_sessions,
  R.identity
);

export const getEnabledSectionsMenu = createSelector(
  getters.enableManageProfile,
  getHasResources,
  getHasFiles,
  getShouldShowSessions,
  (enableManageProfile, hasResources, hasFiles, shouldShowSessions) => {
    let menu = [...SECTIONS_MENU];
    if (!enableManageProfile) {
      menu = menu.filter(s => s.id !== SECTIONS_IDS.PROFILE);
    }
    if (!hasResources) {
      menu = menu.filter(s => s.id !== SECTIONS_IDS.RESOURCES);
    }
    if (!hasFiles) {
      menu = menu.filter(s => s.id !== SECTIONS_IDS.FILES);
    }
    if (!shouldShowSessions) {
      menu = menu.filter(s => s.id !== SECTIONS_IDS.SESSIONS);
    }
    return menu;
  }
);

export const getVisibleSessionFieldIds = createSelector(
  getters.visibleSessionFieldIds,
  visibleSessionFieldIds => {
    return visibleSessionFieldIds;
  }
);

export * from "./styles";
